import styled from 'styled-components'

const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.colors.cardShadow};

  @media (max-width: 720px) {
    flex-wrap: wrap;
  }
`

const NavigationButton = styled.button`
  background-color: ${({ theme }) => (theme.mode === 'dark' ? '#6366f1' : theme.colors.primary)};
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: ${({ theme }) =>
    theme.mode === 'dark' ? '0 4px 16px rgba(99, 102, 241, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.1)'};
  transition:
    background-color 0.3s ease,
    transform 0.2s ease,
    box-shadow 0.3s ease;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#7c3aed' : theme.colors.primaryHover)};
    transform: translateY(-2px) scale(1.02);
    box-shadow: ${({ theme }) =>
      theme.mode === 'dark' ? '0 6px 20px rgba(124, 58, 237, 0.4)' : '0 6px 16px rgba(0, 0, 0, 0.15)'};
  }

  &:active:not(:disabled) {
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#5b21b6' : theme.colors.primaryActive)};
    transform: translateY(0) scale(0.98);
    box-shadow: ${({ theme }) =>
      theme.mode === 'dark' ? '0 2px 12px rgba(91, 33, 182, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)'};
  }

  &:disabled {
    background-color: ${({ theme }) =>
      theme.mode === 'dark' ? theme.colors.surfaceMuted : theme.colors.surfaceElevated};
    color: ${({ theme }) => theme.colors.textSecondary};
    border: 2px solid ${({ theme }) => theme.colors.border};
    cursor: not-allowed;
    box-shadow: none;
    opacity: ${({ theme }) => (theme.mode === 'dark' ? 0.7 : 0.6)};

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }

  @media (max-width: 720px) {
    flex: 1 1 calc(50% - 6px);
    justify-content: center;
  }
`

const HistoryInfo = styled.div`
  flex: 1;
  text-align: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 14px;
  font-weight: 500;

  @media (max-width: 720px) {
    flex: 1 1 100%;
    order: 1;
  }
`

const HistoryTimestamp = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.muted};
  margin-top: 2px;
`

export function HistoryNavigation({ currentIndex, totalItems, onNavigate, currentTimestamp }) {
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return ''
    const date = new Date(timestamp)
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  if (totalItems === 0) return null

  const isNewCalculation = currentIndex === -1

  return (
    <NavigationContainer>
      <NavigationButton onClick={() => onNavigate(-1)} disabled={currentIndex <= 0}>
        ← Mais recente
      </NavigationButton>
      <HistoryInfo>
        {isNewCalculation ? (
          <>
            Novo cálculo (0 de {totalItems})
            <HistoryTimestamp>
              Histórico disponível: {totalItems} cálculo{totalItems > 1 ? 's' : ''}
            </HistoryTimestamp>
          </>
        ) : (
          <>
            Cálculo {currentIndex + 1} de {totalItems}
            {currentTimestamp && <HistoryTimestamp>{formatTimestamp(currentTimestamp)}</HistoryTimestamp>}
          </>
        )}
      </HistoryInfo>
      <NavigationButton
        onClick={() => onNavigate(1)}
        disabled={isNewCalculation ? false : currentIndex >= totalItems - 1}
      >
        {isNewCalculation ? 'Ver histórico →' : 'Mais antigo →'}
      </NavigationButton>
    </NavigationContainer>
  )
}
